import React, { useRef } from "react";
import json from "../data.json";
import Video from './Video';
import Images from'./Images';
import HeaderImage from '../assets/rokbak_map_final.jpg';
import Arrow from '../assets/svg/arrow.svg';

import '../styles/accordion.scss';
import '../styles/accordion_cta.scss';


const Accordion = () => {

  const click = () => {
    document.querySelectorAll('iframe').forEach(v => { v.src = v.src });
  }

  const listItems = json.map((item, index) => {
    if (item.type === "video+nav" || item.type === "video--warning" || item.type === "video--speaker") {
      return (
        <li key={item.id} className="accordion__item">
          <input type="radio" name="first" id={item.id} defaultChecked={index === 0} onClick={click} />
          <label for={item.id} className="accordion__label">
            <div className="accordion__img">
              <img src={Images[item.id - 1] } alt="" />
            </div>
            { item.type === "video+nav" ? 
              <h4 className="h4 accordion__title">{item.id}. {item.title}</h4> :
              <h4 className="h4 accordion__title">{item.title}</h4>
            }
            <i className="accordion__icon"></i>
          </label>
          <div className="accordion__content">
            <Video videoSrc={item.url} id={item.id}/>
            <p className="para">{item.description}</p>
          </div>
        </li>
      )
    } else if (item.type !== "video+nav" && item.type !== "video--warning" && item.type !== "video--speaker") {
      return (
        <li className="accordion-cta">
          <a href={item.url} target="_blank" rel="noopener noreferrer" className="accordion-cta__link">
            <div className="accordion__img">
              <img src={Images[item.id - 1] } alt="" />
            </div>
            <div className="h4 accordion-cta__title">{item.title}<img src={Arrow} alt="arrow" /></div>
          </a>
        </li>
      )
    }
  })
   
  return (
    <>
      <div className="layout-item-full-width accordion__header">
        <img src={HeaderImage} alt="" className="accordion__header__image"/>
      </div>
      <div className="layout-item-full-width accordion">
        <ul className="accordion__list">
          {listItems}
        </ul>
      </div>
    </>
  );
}


export default Accordion
